module.exports = __webpack_public_path__ + "static/media/5.ef8e1ab0.svg";